import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  graphContainer: {
    height: 400,
    position: "relative",
    marginTop: "20px",
    padding: 0,
  },
  selectHeader: {
    padding: "2rem 1rem 0 1rem",
  },
  wrapper: {
    padding: 20,
    backgroundColor: "white",
    borderRadius: "10px",
  },
  noDataMessage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  toggleWrapper: {
    display: "inline-flex",
    justifyContent: "start",
  },
  chartNoData: {
    background: "#ededed",
    height: "400px",
    borderRadius: "0.25rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "40px",
  },
}));
